import type {
  College,
  CollegeLetterGroup
} from "rivals/shared/interfaces/College";

export interface Conference {
  abbreviation: string;
  colleges?: College[];
  id: number;
  name: string;
}

export interface ConferenceGroups {
  groupOfFive: Conference[];
  nonGrouped: Conference[];
  powerConf: Conference[];
}

// Type guard to differentiate between conference and collegeGroup
export const isConference = (
  conference: Conference | CollegeLetterGroup
): conference is Conference => {
  if ((conference as Conference).name !== undefined) {
    return true;
  }
  return false;
};
